import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { VehicleType, LicenseType, Zone } from '@/interfaces/new-license-request/new-license-request-interfaces';
import { FormGroup, FormControl, FormArray, Validators, AbstractControl } from '@angular/forms';
import { CompleteLicense } from '@/interfaces/dashboard/licenses';
import { normalize } from '@/utils/normalizeString';
import { mustSelectOneThatIsNotDisabled } from '../new-record.validators';
import { NewEquipmentRow } from '../new-record.interfaces';
import { RecordType } from '../../form.interfaces';

@Component({
  selector: 'app-zone',
  templateUrl: './zone.component.html',
  styleUrls: ['./zone.component.css'],
})
export class ZoneComponent implements OnInit {
  @Input() selectedOption: RecordType = 'NONE';
  @Input() vehicleTypes: VehicleType[] = [];

  @Input()
  set licenseTypes(licenseTypes: LicenseType[]) {
    const formArray = this.newEquipmentForm.controls.licenseTypes as FormArray;

    licenseTypes.map((item) => {
      formArray.push(new FormGroup({
        id: new FormControl(item.id),
        name: new FormControl(item.name),
        active: new FormControl(false),
        disabled: new FormControl(false),
      }));
    });

    this._licenseTypes = licenseTypes;
  }
  get licenseTypes(): LicenseType[] {
    return this._licenseTypes;
  }
  _licenseTypes: LicenseType[] = [];

  @Input()
  set conductionZones(conductionZones: Zone[]) {
    const formArray = this.newEquipmentForm.controls.conductionZones as FormArray;

    conductionZones.map((item) => {
      formArray.push(new FormGroup({
        id: new FormControl(item.id),
        name: new FormControl(item.name),
        active: new FormControl(false),
        disabled: new FormControl(false),
      }));
    });

    this._conductionZones = conductionZones;
  }
  get conductionZones(): Zone[] {
    return this._conductionZones;
  }
  _conductionZones: Zone[] = [];

  @Input()
  set selectedVehicle(selectedVehicleParam: CompleteLicense['equipments'][0] | null) {
    this._selectedVehicle = selectedVehicleParam;
    if (selectedVehicleParam === null) {
      this.resetForm();
    }
    else {
      this.setDefaultValues(selectedVehicleParam);
    }
  }
  get selectedVehicle(): CompleteLicense['equipments'][0] | null {
    return this._selectedVehicle;
  }
  _selectedVehicle: CompleteLicense['equipments'][0] | null = null;

  @Output() addEquipment = new EventEmitter<NewEquipmentRow>();

  newEquipmentForm: FormGroup = new FormGroup({
    vehicleType: new FormControl('', [Validators.required]),
    brand: new FormControl(''),
    model: new FormControl(''),
    licenseTypes: new FormArray([]),
    conductionZones: new FormArray([], [mustSelectOneThatIsNotDisabled()]),
  });

  constructor() { }

  ngOnInit(): void {
  }

  onAddNewEquipment() {
    this.addEquipment.emit(this.newEquipmentForm.value as NewEquipmentRow);
    this.resetForm();
  }

  round(num: number) {
    return Math.ceil(num);
  }

  setDefaultValues(selectedVehicle: CompleteLicense['equipments'][0]) {

    const {
      licenseTypes: licenseTypesControl,
      conductionZones: conductionZonesControl,
    } = this.newEquipmentForm.controls as { [x: string]: FormArray };

    const selectedLicenseIds = selectedVehicle.licenseTypes
      .map((selectedName) => this.licenseTypes.find(({ name }) => normalize(name) === normalize(selectedName)))
      .map((type) => type?.id);

    licenseTypesControl.controls.map((control) => {
      const isSelectedByDefault = selectedLicenseIds.indexOf(control.value.id) >= 0;

      control.patchValue({
        active: isSelectedByDefault,
        disabled: isSelectedByDefault,
      });
    });

    const conductionZoneIds = selectedVehicle.conductionZones
      .map((selectedName) => this.conductionZones.find(({ name }) => normalize(name) === normalize(selectedName)))
      .map((type) => type?.id);

    conductionZonesControl.controls.map((control) => {
      const isSelectedByDefault = conductionZoneIds.indexOf(control.value.id) >= 0;
      control.patchValue({
        active: isSelectedByDefault,
        disabled: isSelectedByDefault,
      });
    });

    const {
      vehicleType: vehicleTypeControl,
      brand: brandControl,
      model: modelControl,
    } = this.newEquipmentForm.controls as { [x: string]: FormControl };

    vehicleTypeControl.setValue(selectedVehicle.equipmentVehicleType);
    brandControl.setValue(selectedVehicle.equipmentBrand);
    modelControl.setValue(selectedVehicle.equipmentModel);
  }

  resetForm() {
    const { conductionZones } = this.newEquipmentForm.controls as { [x: string]: FormArray };
    for (let index = 0; index < conductionZones.controls.length; index++) {
      const control = conductionZones.at(index) as FormGroup;
      if (!control.controls.disabled.value) {
        control.controls.active.setValue(false);
      }
    }
  }

  getCheckControls(id: number): { [x: string]: FormControl } {
    let indexReq = -1;
    const formSectionType = this.asFormArray(this.newEquipmentForm.controls.conductionZones)

    formSectionType.value.some(({ id: rowIndex }: any, formArrayIndex: number) => {
      if (rowIndex === id) {
        indexReq = formArrayIndex;
      }
    });
    const formGroup = formSectionType.at(indexReq) as FormGroup;
    return formGroup.controls as { [x: string]: FormControl };
  }

  asFormArray(control: AbstractControl) {
    return control as FormArray;
  }

  asFormControl(control: AbstractControl) {
    return control as FormControl;
  }

  asFormGroup(control: AbstractControl) {
    return control as FormGroup;
  }

}
